// Utility to extract and join error messages from a Record<string, string> or array of error objects
export function extractError(
  errors: Record<string, string> | { path: string; message: string }[] | null | undefined
): string {
  if (!errors) return "An unknown error occurred.";

  // If errors is an array of error objects
  if (Array.isArray(errors)) {
    return errors.map(e => e?.message || "").filter(Boolean).join(", ");
  }

  // If errors is a record
  if (typeof errors === "object") {
    return Object.values(errors).filter(Boolean).join(", ");
  }

  return String(errors);
}
